import {
  ArrowsLeftRightIcon,
  ArrowUDownLeftIcon,
  CoinsIcon,
  HandbagSimpleIcon,
  TShirtIcon,
  UserCircleIcon,
} from '@phosphor-icons/react'

export const supportEmail = 'merchants@reveni.io'

export const actionsReasons = {
  notSupported: 'not_supported',
  pickupScheduled: 'pickup_scheduled',
  maxReturnLabels: 'max_return_labels',
}

export const refundMethods = {
  originalPaymentMethod: 'original_payment_method',
}

export const cancellationErrorCodes = {
  giftCardNotFound: 'gift_card_not_found',
  giftCardSyncError: 'gift_card_sync_error',
  giftCardNotRedeemable: 'gift_card_not_redeemable',
  storeCreditNotFound: 'store_credit_not_found',
  storeCreditSyncError: 'store_credit_sync_error',
  storeCreditNotRedeemable: 'store_credit_not_redeemable',
  storeConnectionError: 'store_connection_error',
}

export const actionsMenuSections = [
  {
    label: 'Transacción',
    Icon: HandbagSimpleIcon,
    id: 6,
  },
  {
    label: 'Productos',
    Icon: TShirtIcon,
    id: 1,
  },
  {
    label: 'Reembolso / Pago',
    Icon: CoinsIcon,
    id: 2,
  },
  {
    label: 'Cliente',
    Icon: UserCircleIcon,
    id: 3,
  },
  {
    label: 'Devolución',
    Icon: ArrowUDownLeftIcon,
    id: 4,
  },
  {
    label: 'Cambios',
    Icon: ArrowsLeftRightIcon,
    id: 5,
  },
]
